
// src/environments/environment.staging.ts

export const environment = {
  production: false, // <= Esto debe ser FALSE para staging/desarrollo
  environmentName: 'staging',
  loginUrl: 'https://stockfy.co/#/authentication/signin',

  // Backend API (Staging)
  apiUrl: 'https://apidev.stockfy.co',
  apiUrlModel: 'https://apidev.stockfy.co/public/models',
  apiUrlUser: 'https://apidev.stockfy.co/users',
  apiBase: 'https://apidev.stockfy.co',
  apiBaseUrl: 'https://cpanel-development.stockfy.co',
};

